<!-- /** 左边菜单 **/ -->
<template>
  <div class="letnav">
    <div class="letnav_top">
      <div class="logobox">
        <img
          class="logoimg"
          src="../assets/img/logo.3cd85a53.png"
          alt=""
        /><span v-if="!collapsed">3699-BI数据分析与可视化平台</span>
      </div>
    </div>
    <el-aside :width="collapsed ? '64px' : '240px'">
      <el-menu
        background-color="#334157"
        text-color="#fff"
        active-text-color="#409EFF"
        unique-opened
        :collapse-transition="false"
        router
        :collapse="collapsed"
        >
        <!-- 一级菜单 -->
        <el-submenu
          :index="item.id + ''"
          v-for="item in allmenu"
          :key="item.id"
        >
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span>{{ item.authName }}</span>
          </template>
          <!-- 二级菜单 -->
          <el-menu-item
            :index="'/' + item2.path"
            v-for="item2 in item.children"
            :key="item2.id"
          >
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>{{ item2.authName }}</span>
            </template>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>
  </div>
</template>
<script>
import menus from "@/utils/menus.json";
import { ConvertArray, fn } from "@/utils/public";
import { getCookie } from '../utils/util';
export default {
  data() {
    return {
      collapsed: false,
      allmenu: [],
      ChildNode: [], //角色列表的菜单id
      role_id: 0,
      salesman_id: 0,
      app_id: 0,
      channel_id: 0,
      info_show_type: 0,
      write_type: 0
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.getmenus();
    // this.allmenu = menus;
    this.$root.Bus.$on("toggle", value => {
      this.collapsed = !value;
    });
  },
  methods: {
    async getmenus() {
      this.role_id = getCookie("role_id");
      console.log("this.role_id" + this.role_id);
      await this.$axios
        .post("/3699BIApi/AdminRole/AllChildren", { "role_id": Number.parseInt(this.role_id) })
        .then(res => {
          console.log(res);
          if (res.data.code == 200 && res.data.total > 0) {
            this.ChildNode = ConvertArray(res.data.list[0].children);
            console.log("ChildNode" + this.ChildNode);
            this.getIntersection(this.ChildNode);
          }
        });
    },

    getIntersection(array) {
      var threeArray = [];
      for (var i = 0; i < menus.length; i++) {
        var itemObject1 = menus[i];
        var fID = `${itemObject1.id}`;
        var isHaveFID = false;
        for (var j = 0; j < array.length; j++) {
          var value2 = array[j];
          if (fID == value2) {
            isHaveFID = true;
          }
        }

        if (isHaveFID == true) {
          var temp = {};
          for (var k in itemObject1) {
            if (k == "children") {
              var oldChildren = itemObject1[k];
              var newChildren = {};
              for (var l in oldChildren) {
                newChildren[l] = oldChildren[l];
              }
              temp.children = newChildren;
            } else {
              temp[k] = itemObject1[k];
            }
          }
          threeArray.push(temp);
        } else {
          var oldChildren = itemObject1.children;
          var newItemObject = {
            children: []
          };
          var isFirstChildren = true;
          for (var j = 0; j < oldChildren.length; j++) {
            var itemObject2 = oldChildren[j];
            var item2Id = itemObject2.id;
            var isHaveCID = false;
            for (var k = 0; k < array.length; k++) {
              var value2 = array[k];
              if (item2Id == value2) {
                isHaveCID = true;
                break;
              }
            }
            if (isHaveCID == true) {
              if (isFirstChildren == true) {
                isFirstChildren = false;
                for (var l in itemObject1) {
                  if (l != "children") {
                    newItemObject[l] = itemObject1[l];
                  }
                }
              }
              var newChildren = {};
              for (var l in itemObject2) {
                newChildren[l] = itemObject2[l];
              }
              newItemObject.children.push(newChildren);
            }
          }
          if (isFirstChildren == false) {
            threeArray.push(newItemObject);
          }
        }
      }
      this.allmenu = threeArray;
    }
  }
};
</script>
<style lang="scss" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  width: 100%;
  height: 56px;
  /* line-height: 40px; */
  color: #9d9d9d;
  font-size: 20px;
  /* text-align: center;
  padding: 20px 0px; */
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    background-image: linear-gradient(135deg, yellow, white);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
  }
}
.logoimg {
  height: 40px;
  padding-right: 10px;
}
.el-submenu {
  overflow: hidden;
}
.letnav,
.el-aside {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue